var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "has-logo": _vm.showLogo, "left-nav": true },
      staticStyle: { display: "flex", "flex-direction": "column" },
    },
    [
      _c("div", { staticClass: "scrollbarLogo" }, [
        !_vm.isCollapse
          ? _c("img", {
              style: _vm.sidebar.opened ? "margin-right:0px;" : "",
              attrs: {
                src:
                  _vm.styleTheme.table === "table_maomao_1"
                    ? _vm.logoW
                    : _vm.logoB,
              },
            })
          : _c("img", {
              staticClass: "minlogo",
              style: _vm.sidebar.opened ? "margin-right:0px;" : "",
              attrs: {
                src:
                  _vm.styleTheme.table === "table_maomao_1"
                    ? _vm.minlogoW
                    : _vm.minlogo,
              },
            }),
      ]),
      _vm.showLogo
        ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
        : _vm._e(),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c(
            "el-menu",
            {
              ref: "menu",
              attrs: {
                "default-active": _vm.activeMenu,
                collapse: _vm.isCollapse,
                "background-color":
                  !_vm.styleTheme.menuBg || _vm.styleTheme.menuBg === "1"
                    ? _vm.variables.menuBg
                    : _vm.variables.menuBgWhite,
                "text-color":
                  !_vm.styleTheme.menuBg || _vm.styleTheme.menuBg === "1"
                    ? _vm.variables.menuText
                    : _vm.variables.menuTextWhite,
                "unique-opened": false,
                "active-text-color": _vm.yanse,
                "collapse-transition": false,
                mode: "vertical",
              },
            },
            _vm._l(_vm.leftMenuList, function (route, index) {
              return _c(
                "el-submenu",
                {
                  key: index,
                  staticStyle: { position: "relative" },
                  attrs: { index: _vm.resolvePath(route.path) },
                },
                [
                  _c("template", { slot: "title" }, [
                    route.meta.icon && !route.meta.src
                      ? _c("i", {
                          class: route.meta.icon
                            ? "iconfont sub-el-icon " + route.meta.icon
                            : "iconfont sub-el-icon",
                          style:
                            route.path.indexOf("fang-wei") != -1
                              ? "color:orange"
                              : route.path.indexOf("product-manager") != -1
                              ? "color:#a6d6d5"
                              : route.path.indexOf("performance") != -1
                              ? "color:#6184f7"
                              : route.path.indexOf("finance-manager") != -1
                              ? "color:#f63734"
                              : "",
                        })
                      : _vm._e(),
                    route.meta.icon && route.meta.src
                      ? _c("img", {
                          class: [
                            "iconfont",
                            route.meta.right ? "sub-el-icon-1" : "sub-el-icon",
                          ],
                          style: route.meta.width
                            ? route.meta.width
                            : "width: 16px !important",
                          attrs: { src: route.meta.src },
                        })
                      : _vm._e(),
                    _c(
                      "span",
                      {
                        staticStyle: { "font-family": "auto" },
                        style: route.meta.spanL,
                      },
                      [_vm._v(" " + _vm._s(route.meta.title) + " ")]
                    ),
                    _vm.sidebar.opened &&
                    "/" +
                      _vm.activeMenu.toString().split("/")[1].split("/")[0] ===
                      route.path
                      ? _c("div", {
                          staticClass: "shuxian_m",
                          style: "background:" + _vm.yanse + ";",
                        })
                      : _vm._e(),
                  ]),
                  route.children && route.children.length
                    ? [
                        _c(
                          "el-menu-item-group",
                          [
                            _vm._l(
                              route.children,
                              function (child, childIndex) {
                                return [
                                  _c(
                                    "el-menu-item",
                                    {
                                      attrs: {
                                        index: _vm.resolvePath(
                                          child.path,
                                          route.path,
                                          1
                                        ),
                                      },
                                    },
                                    [
                                      _c(
                                        "AppLink",
                                        {
                                          staticStyle: { display: "flex" },
                                          attrs: {
                                            to: _vm.resolvePath(
                                              child.path,
                                              route.path,
                                              1
                                            ),
                                            base: route.path,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticStyle: { width: "16px" } },
                                            [
                                              _c("i", {
                                                class: child.meta.icon
                                                  ? "iconfont sub-el-icon " +
                                                    child.meta.icon
                                                  : "iconfont sub-el-icon",
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-family": "auto",
                                                flex: "1",
                                              },
                                              style:
                                                child.path === _vm.contentUrl
                                                  ? "color:" + _vm.yanse + ";"
                                                  : "",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(child.meta.title) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ertghu" },
        [
          _c("hamburger", {
            staticClass: "hamburger-container",
            attrs: { "is-active": _vm.sidebar.opened },
            on: { toggleClick: _vm.toggleSideBar },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }